import { __assign } from "tslib";
import * as React from 'react';
import { themes } from '../../ThemeOptions';
var BootStrapTr = React.lazy(function () {
    return import('../../bootstrap-table-components/components/BTTr');
});
var onClick = function (props) {
    if (props.onClick) {
        props.onClick();
    }
};
var bootStrapTr = function (props) {
    var newProps = __assign(__assign({}, props), { onClick: function () { return onClick(props); } });
    return React.createElement(BootStrapTr, __assign({}, newProps));
};
export var Tr = function (props) {
    var componentToDisplay = bootStrapTr(props);
    switch (props.ioTheme.uiLibrary) {
        case 'bootstrap':
            componentToDisplay = bootStrapTr(props);
    }
    return React.createElement(React.Fragment, null, componentToDisplay);
};
Tr.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Tr;
//# sourceMappingURL=Tr.js.map